import React from "react";
import PropTypes from "prop-types";

import UICallout from "../UICallout";
import { clx } from "../../../utils/Helpers";
import "./UIProfileCompleteness.scss";
const UIProfileCompleteness = ({
  // percent,
  missingFields,
  // completeLabel,
  // fieldsMissingLabel,
  missingFieldsTitle,
  missingOptionalFields,
  missingOptionalFieldsTitle,
  className,
}) => (
  <div className={clx("ui-profile-completeness", className)}>
    {/* <div className="ui-profile-completeness__progress-box">
      <div className="ui-profile-completeness__summary">
        <div className="ui-profile-completeness__percent-block">
          <span className="ui-profile-completeness__percent">{percent}%</span>
          {completeLabel ? (
            <span className="ui-profile-completeness__complete-label">
              {completeLabel}
            </span>
          ) : null}
        </div>
        {fieldsMissingLabel ? (
          <span className="ui-profile-completeness__missing-count">
            {fieldsMissingLabel}
          </span>
        ) : null}
      </div>
     
       </div> */}
    {missingFields?.length > 0 ? (
      <UICallout
        variant="error"
        hasBorder
        className="ui-profile-completeness__alert"
        title={missingFieldsTitle}
        description={missingFields.join(" · ")}
      />
    ) : null}
    {missingOptionalFields?.length > 0 ? (
      <UICallout
        variant="warning"
        hasBorder
        className="ui-profile-completeness__alert"
        title={missingOptionalFieldsTitle}
        description={missingOptionalFields.join(" · ")}
      />
    ) : null}
  </div>
);

UIProfileCompleteness.propTypes = {
  percent: PropTypes.number.isRequired,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  completeLabel: PropTypes.string,
  fieldsMissingLabel: PropTypes.string,
  missingFieldsTitle: PropTypes.string,
  missingOptionalFields: PropTypes.arrayOf(PropTypes.string),
  missingOptionalFieldsTitle: PropTypes.string,
  className: PropTypes.string,
};

UIProfileCompleteness.defaultProps = {
  missingFields: [],
  completeLabel: "",
  fieldsMissingLabel: "",
  missingFieldsTitle: "",
  missingOptionalFields: [],
  missingOptionalFieldsTitle: "",
  className: "",
};

export default UIProfileCompleteness;
